import { get, merge } from "lodash";
import { REHYDRATE } from "redux-persist/constants";
import { LOGIN, AUTH_UPDATE } from "@irati/auth/store/actions/AuthActions";
import defaultTenant from "@irati/identity/helpers/defaultTenant";
import { UPDATE_BRAND } from "./Actions";
import updateBrand from "../helpers/updateBrand";
export default (function (state, action) {
    if (state === void 0) { state = {}; }
    var _a = action.auth, auth = _a === void 0 ? {} : _a;
    switch (action.type) {
        case UPDATE_BRAND:
        case LOGIN:
        case AUTH_UPDATE:
            updateBrand(auth.userTenant);
            return state;
        case REHYDRATE:
            updateBrandFromRehydrate(action);
            return state;
        default:
            return state;
    }
});
function updateBrandFromRehydrate(action) {
    var auth = action.payload.auth;
    var persistedTenant = get(auth, "userTenant") || {};
    var userTenant = merge({}, persistedTenant, defaultTenant);
    updateBrand(userTenant);
}
